<template>
  <div class="yes-no-cell-renderer">
    {{ cellValue }}
  </div>
</template>

<script setup>
import { computed, toRefs } from 'vue'

const props = defineProps({
  params: {
    type: Object,
    default: () => ({}),
  },
})
const { params } = toRefs(props)

const cellValue = computed(() => {
  if (params.value.value === params.value.yesValue) return 'Yes'
  if (params.value.value === params.value.noValue) return 'No'
  return params.value.value
})
</script>
